module.exports = __webpack_public_path__ + "img/chatbot8.235a3932.svg";